import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import  utils from '../../../utils';
import { Contact } from './contactForm';

export function ContactForm(props) {
  const item = props.item;
  console.log('item', item);
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};

  //console.log('item', item, cmsOption);

  const emailReceiver = cmsUtils.payload(item, 'EmailReceiver');
  const emailReceiverACT = cmsUtils.payload(item, 'EmailReceiverACT');
  const emailReceiverNSW = cmsUtils.payload(item, 'EmailReceiverNSW');
  const emailReceiverNT = cmsUtils.payload(item, 'EmailReceiverNT');
  const emailReceiverQLD = cmsUtils.payload(item, 'EmailReceiverQLD');
  const emailReceiverSA = cmsUtils.payload(item, 'EmailReceiverSA');
  const emailReceiverTAS = cmsUtils.payload(item, 'EmailReceiverTAS');
  const emailReceiverVIC = cmsUtils.payload(item, 'EmailReceiverVIC');
  const emailReceiverWA = cmsUtils.payload(item, 'EmailReceiverWA');
  const emailReceiverInternational = cmsUtils.payload(item, 'EmailReceiverInternational');
  const fileAttachment = cmsUtils.payload(item, 'FileAttachment') || "false";

  const mailchimpApiKey = cmsUtils.payload(item, 'MailchimpApiKey');
  const mailchimpAudienceKey = cmsUtils.payload(item, 'MailchimpAudienceKey');

  const cssClass = utils.classNames('cms_item', 'htmlPanel', cmsOption.isCmsEdit && 'html', item.cssClass || item.anchorName || '');

  //let itemElt = (<div dangerouslySetInnerHTML={{ __html: content }}></div>);

  return (
    <div className={cssClass} data-cms-html="true"
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>

      <div className="container contact-wrapper" id="contactForm">
        <Contact 
          emailReceiver={emailReceiver} 
          emailReceiverACT={emailReceiverACT}
          emailReceiverNSW={emailReceiverNSW}
          emailReceiverNT={emailReceiverNT}
          emailReceiverQLD={emailReceiverQLD}
          emailReceiverSA={emailReceiverSA}
          emailReceiverTAS={emailReceiverTAS}
          emailReceiverVIC={emailReceiverVIC}
          emailReceiverWA={emailReceiverWA}
          emailReceiverInternational={emailReceiverInternational}
          fileAttachment={fileAttachment} 
          mailchimpApiKey={mailchimpApiKey} 
          mailchimpAudienceKey={mailchimpAudienceKey} 
        />
      </div>

    </div>
  )
}